import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/features/auth';
import { HomeFilterProvider } from '../components/HomeFilterContext';
import { HomeFilterBar } from '../components/HomeFilterBar';
import { WidgetGrid } from '../components/widgets';

function getGreetingKey(): string {
  const h = new Date().getHours();
  if (h < 6) return 'home.greeting.night';
  if (h < 12) return 'home.greeting.morning';
  if (h < 17) return 'home.greeting.afternoon';
  if (h < 21) return 'home.greeting.evening';
  return 'home.greeting.night';
}

export default function HomePage() {
  const { t, i18n } = useTranslation();
  const user = useAuthStore((s) => s.user);
  const fullName = (() => {
    if (!user) return '';
    if (i18n.language === 'he' && user.firstNameHe) {
      return `${user.firstNameHe} ${user.lastNameHe || user.lastName}`;
    }
    return `${user.firstName} ${user.lastName}`;
  })();

  return (
    <HomeFilterProvider>
      <div className="pb-32">
        <HomeFilterBar />
        <div className="px-4 md:px-10 mt-6 mb-2" dir="auto">
          <h1 className="text-lg font-semibold" style={{ color: 'var(--user-page-heading)' }}>
            {t(getGreetingKey())}, <span className="font-extrabold">{fullName}</span>
          </h1>
        </div>
        <WidgetGrid />
      </div>
    </HomeFilterProvider>
  );
}
